module.exports = __webpack_public_path__ + "img/belgium-cancer-male.98d07a63.png";